<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="subscriptionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Subscribe</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Name</label>
                            <input type="text" v-model="name" placeholder="Enter name" class="form-control" required>
                        </div>
                        <div class="form-group">
                            <label>Surname</label>
                            <input type="text" v-model="surname" placeholder="Enter surname" class="form-control">
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input type="email" v-model="email" placeholder="Enter email" class="form-control" required>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" v-on:click="subscribe" class="btn btn-primary">Subscribe</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->

        <!-- Subscription Response Modal -->
        <div class="modal fade" id="responseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 v-if="201 === response.status" class="modal-title">Success</h5>
                        <h5 v-if="201 !== response.status" class="modal-title">Error</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p v-if="201 === response.status" >Success!! You have been Subscribed</p>
                        <p v-if="201 !== response.status" >There seems to have been an error please contact us: <strong>info@7settembru.org</strong></p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
    </div>
</template>

<script>

    import {RepositoryFactory} from "../../repositories/RepositoryFactory";

    const SubscriptionRepository = RepositoryFactory.get('newsletter');
    const LISTING_ID = process.env.VUE_APP_LISTING_ID;

    export default {
        name: 'SubscriptionModals',
        data() {
            return {
                email: '',
                name: '',
                surname: '',
                response: Object,
            }
        },
        methods: {
            subscribe () {
                SubscriptionRepository.createSubscription(LISTING_ID,
                    {
                        'customer' : {
                            name: this.name,
                            surname: this.surname,
                            email: this.email,
                        }
                    }).then(response => (
                        this.response = response,
                            $('#subscriptionModal').modal('hide'),
                            $('#responseModal').modal('show')
                    )
                )
            }
        },
    }
</script>
